import { createSvgIcon } from '@material-ui/core/utils';

export const MarketplaceGraphIcon = createSvgIcon(
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6667 5.33335C14.6667 7.54249 12.8758 9.33335 10.6667 9.33335C8.45753 9.33335 6.66667 7.54249 6.66667 5.33335C6.66667 3.12421 8.45753 1.33334 10.6667 1.33334C12.8758 1.33334 14.6667 3.12421 14.6667 5.33335Z" />
    <path d="M4 12.6667C5.47276 12.6667 6.66667 11.4728 6.66667 10C6.66667 8.52726 5.47276 7.33336 4 7.33336C2.52724 7.33336 1.33334 8.52726 1.33334 10C1.33334 11.4728 2.52724 12.6667 4 12.6667Z" />
    <path d="M10.3333 14.6667C11.2538 14.6667 12 13.9205 12 13C12 12.0795 11.2538 11.3333 10.3333 11.3333C9.41287 11.3333 8.66667 12.0795 8.66667 13C8.66667 13.9205 9.41287 14.6667 10.3333 14.6667Z" />
  </svg>,
  'MarketplaceGraphIcon',
);
